module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "our-people"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "aligncenter top-text",
    domProps: {
      "innerHTML": _vm._s(_vm.heading_text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "our-people-swiper-container swiper-container wide-slider"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('a', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "bg",
      style: ({
        'background-image': 'url( ' + slide.image.url + ' )'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(slide.name))]), _vm._v(" "), _c('div', {
      staticClass: "status"
    }, [_vm._v(_vm._s(slide.status))])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "our-people-swiper-prev wide-slider-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "our-people-swiper-next wide-slider-next"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b197d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurPeopleSlider.vue
// module id = 356
// module chunks = 0